export var ExpressFulfilmentAvailabilityStatusResponse;
(function (ExpressFulfilmentAvailabilityStatusResponse) {
    ExpressFulfilmentAvailabilityStatusResponse.AvailabilityStatusEnum = {
        Available: 'Available',
        ExpressWindowAlreadySelected: 'ExpressWindowAlreadySelected',
        NoExpressWindows: 'NoExpressWindows',
        OutOfHours: 'OutOfHours',
        StoreDoesNotSupportExpress: 'StoreDoesNotSupportExpress',
        WindowLimitExceeded: 'WindowLimitExceeded'
    };
})(ExpressFulfilmentAvailabilityStatusResponse || (ExpressFulfilmentAvailabilityStatusResponse = {}));
